import Button from './Button';

function ConfirmModal({
  open,
  title,
  children,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  confirming = false,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 p-4 sm:items-center"
      role="dialog"
      aria-modal="true"
      onClick={confirming ? undefined : onCancel}
    >
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-lg" onClick={(event) => event.stopPropagation()}>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        {children && <div className="mt-3 flex flex-col gap-1 text-sm text-gray-600">{children}</div>}

        <div className="mt-6 flex flex-col gap-3">
          <Button variant="primary" onClick={onConfirm} disabled={confirming}>
            {confirming ? 'Procesando...' : confirmLabel}
          </Button>
          <Button variant="secondary" onClick={onCancel} disabled={confirming}>
            {cancelLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
